if (document.querySelector('[data-gumshoe]')) {
  init()
}

function init () {
  let $navLinks = Array.from(document.querySelectorAll('[data-gumshoe] a[href^="#"]'))
  let $sections = $navLinks.map($link => document.getElementById($link.getAttribute('href').substr(1)))

  import(/* webpackChunkName: 'gumshoe' */ 'gumshoejs').then(Gumshoe => {
    if (typeof Gumshoe === 'undefined') {
      return
    }

    const gumshoe = new Gumshoe('[data-gumshoe] a[href^="#"]', {})

    // Event that occurs when a new item is chosen
    document.addEventListener('gumshoeActivate', customEvent => {
      const $li = customEvent.target

      let index = -1
      if ($li) {
        // Pull the index out based on which nav item we clicked
        index = $navLinks.indexOf($li.querySelector('.js-scroll-to'))
      }

      // Iterate the sections and if one of them matches the index we just picked, add/remove highlights
      $sections.forEach(($section, i) => {
        $section.classList.remove('is-current')
        $section.classList.remove('is-active')

        if (i === index) {
          $section.classList.add('is-current')
        } else if (i <= index) {
          $section.classList.add('is-active')
        }
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/_scroll-spy.js